/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import HeroBanner from "./HeroBanner.container";

export default HeroBanner;
